import SHSkeleton from "@components/design-systems/sh-skeleton";
import { SHStack } from "@components/design-systems";

type MSFilterLabelSkeletonProps = {
  showIcon?: boolean;
};

export const MSFilterLabelSkeleton = ({
  showIcon = true,
}: MSFilterLabelSkeletonProps) => {
  return (
    <SHStack
      flexDirection={"row"}
      justifyContent={"space-between"}
      alignItems={"center"}
    >
      <SHSkeleton width={"60%"} height={20} delay={false}></SHSkeleton>
      {showIcon && (<SHSkeleton width={24} height={24} delay={false} variant={"circular"} />)}
    </SHStack>
  );
};
